export default "__VITE_ASSET__DKgL1Che__"